import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const ShareCTA = ({ icon, onPress, variant }) => {
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    return (_jsx(Button, { onPress: onPress, icon: icon, iconOnly: true, variant: variant, size: "40", isDisabled: isPreviewMode, children: t("common.CTA.share.label") }));
};
